/**
 * A `TimeOnly` arrives as `HH:mm:ss`, and the boekje prints `HH:mm`. Cut rather than parsed:
 * a Date built from a bare clock value picks up today's timezone, and the starttijd of a
 * wedstrijd has no timezone to pick up.
 */
export const tijd = (waarde: string) => waarde.slice(0, 5);

/** A `DateOnly` arrives as `yyyy-MM-dd`, and JBNL writes `dd-MM-yyyy`. */
export const datum = (waarde: string) => waarde.split("-").reverse().join("-");
